import { render, staticRenderFns } from "./ReturnPage.vue?vue&type=template&id=31d12a12&scoped=true"
import script from "./ReturnPage.vue?vue&type=script&lang=js"
export * from "./ReturnPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d12a12",
  null
  
)

export default component.exports